import { render } from "./AccountIndexComponent.vue?vue&type=template&id=0f14092d"
import script from "./AccountIndexComponent.vue?vue&type=script&lang=js"
export * from "./AccountIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__